import { View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout, PMSmallTable } from "@pimo/pimo-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { TestAppState } from "../../../app";
import { theme } from "../../../theme";

/** Adds the program team card (#2222). */
export function addProgramTeamCard(
  view: View<TestAppState, DragAndDropLayout>
) {
  const teamComponent = view.addComponent({
    component: PMSmallTable,
    layoutProps: {
      componentId: "projectTeamComponent",
      title: "",
      description: "",
      labels: ["team"],
    },
  });

  teamComponent.mapLayoutProps(({ language }) => ({
    componentId: "projectTeamComponent",
    labels: ["team"],
    title: getLocalizedMessage(language || "en", "projectTeam"),
    description: getLocalizedMessage(language || "en", "showsProjectTeam"),
  }));

  teamComponent.mapState(({ settings, language }) => {
    return {
      title:
        getLocalizedMessage(language || "en", "programTeam") || "Program Team",
      icon: "InfoOutlined",
      items: [
        {
          label:
            settings?.configuration?.projectName === "OE"
              ? "ISO"
              : getLocalizedMessage(language || "en", "programOwner") ||
                "Program Owner",
          value: settings?.configuration?.programOwner ?? "",
          chipColor: theme.palette.secondary.main,
          chipTextColor: theme.palette.primary.main,
          cutValueAfter: 20,
        },
      ],
      fixedHeight: "134px",
    };
  });
}
